// import axios from "./axiosInstance";

// const categoryAPI = {
//   listing: (params) => axios.get(`categories`, { params }),
//   details: (slug) => axios.get(`categories/${slug}`),
// };

// export default categoryAPI;


import axios from "./axiosInstance";
import db from "../data/db.json";

// ─── Mock ─────────────────────────────────────────────────────────────────────
const mockAPI = {
  listing: async () => {
    return db.categoryListing;
  },

  details: async (slug) => {
    const data = db.categoryDetails[slug];

    if (data) return data;

    return {
      code: 404,
      success: false,
      message: "Category not found",
      data: null,
    };
  },
};

// ─── Real ─────────────────────────────────────────────────────────────────────
const realAPI = {
  listing: (params) => axios.get(`categories`, { params }),
  details: (slug) => axios.get(`categories/${slug}`),
};

// ─── Export ───────────────────────────────────────────────────────────────────
const categoryAPI =
  process.env.REACT_APP_USE_MOCK === "true" ? mockAPI : realAPI;

export default categoryAPI;
